import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ICU from 'i18next-icu';

import { IS_EDITOR_MODE } from 'config/envVariable';
import { convertNavigatorLanguage, langTypes } from 'config/gameLangOptions';

// Dynamic imports for new file structure
const loadTranslations = async () => {
    const availableLanguages = ['zh-TW', 'en-US', 'zh-CN', 'ja', 'th', 'es-419', 'pt-BR'];
    const resources = {};
    const folder = IS_EDITOR_MODE ? 'editor' : 'client';

    const loadPromises = availableLanguages.map(async lang => {
        try {
            const translation = await import(`./${folder}/${lang}.json`);
            return { lang, translation: translation.default };
        } catch (error) {
            console.warn(`Failed to load translation for ${lang}:`, error);
            return { lang, translation: null };
        }
    });
    const results = await Promise.all(loadPromises);

    results.forEach(({ lang, translation }) => {
        if (translation) {
            resources[lang] = { translation };
        }
    });

    return resources;
};

const initLang = convertNavigatorLanguage(navigator.language);

// Initialize with empty resources first
i18n.use(ICU)
    .use(initReactI18next)
    .init({
        resources: {},
        lng: initLang,
        fallbackLng: langTypes.ZH_TW,
        keySeparator: false,
        interpolation: {
            escapeValue: false
        }
    });

export let i18nLangOfGame = null;

// Initialize editor game instance if needed
if (IS_EDITOR_MODE) {
    i18nLangOfGame = i18n.createInstance();
    i18nLangOfGame.use(ICU).init({
        resources: {},
        lng: langTypes.ZH_TW,
        fallbackLng: langTypes.ZH_TW,
        keySeparator: false,
        interpolation: {
            escapeValue: false
        }
    });
}

// Load translations asynchronously
loadTranslations()
    .then(resources => {
        // Add resources to main i18n instance
        Object.keys(resources).forEach(lang => {
            i18n.addResourceBundle(lang, 'translation', resources[lang].translation);
        });

        // Add resources to editor game instance if it exists
        if (i18nLangOfGame && IS_EDITOR_MODE) {
            Object.keys(resources).forEach(lang => {
                i18nLangOfGame.addResourceBundle(lang, 'translation', resources[lang].translation);
            });
        }
    })
    .catch(error => {
        console.error('Failed to load translations:', error);
    });

export function setI18nLanguage({ lang, editorGameLang } = {}) {
    let promises = [];
    if (lang !== undefined) {
        document.documentElement.setAttribute('lang', lang);
        promises.push(new Promise(res => i18n.changeLanguage(lang, () => res())));
    }
    if (editorGameLang !== undefined && IS_EDITOR_MODE) {
        promises.push(
            new Promise(res => i18nLangOfGame.changeLanguage(editorGameLang, () => res()))
        );
    }
    return Promise.all(promises);
}
